import "./ManeuverStepper.css";

type Props = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  label?: string;
};

export function ManeuverStepper({ value, onChange, min = 0, max = 99, label }: Props) {
  const count = value || 0;
  const canDec = count > min;
  const canInc = count < max;

  return (
    <div className="maneuver-stepper" role="group" aria-label={label}>
      <button
        type="button"
        className="maneuver-stepper__btn maneuver-stepper__btn--minus"
        onClick={() => onChange(Math.max(min, count - 1))}
        disabled={!canDec}
        aria-label={`${label || "Adet"} azalt`}
      >
        −
      </button>
      <span className="maneuver-stepper__value" aria-live="polite">
        {count}
      </span>
      <button
        type="button"
        className="maneuver-stepper__btn maneuver-stepper__btn--plus"
        onClick={() => onChange(Math.min(max, count + 1))}
        disabled={!canInc}
        aria-label={`${label || "Adet"} artır`}
      >
        +
      </button>
    </div>
  );
}
